/**
 * Real people, and when the app may offer them (BRAND_SPEC §11.1, launch
 * gate 7; TEAM_APP_SPEC §5.5, §8.1).
 *
 * The docked door ("A real person, when you want one. Meet one") and the
 * next-step ladder promise a person, so they show only while people are
 * actually taking requests: publicConfig/sundays.handoff has a switch on.
 *
 * TODO(TEAM_APP_SPEC Lane B): read publicConfig/sundays once per session
 * (src/firebase/publicConfig.js, getSundaysConfig()) and return its
 * `handoff` switches here. Until that lands every switch is off, so neither
 * shows in production: nobody is rostered yet, and a promise nobody keeps is
 * worse than none.
 *
 * A design preview for this browser only (QA, screenshots), never a launch
 * switch: localStorage.setItem('apr-preview-human-steps', 'on').
 */
const PREVIEW_KEY = 'apr-preview-human-steps';
const OFF = Object.freeze({ meet: false, talk: false, seer: false });

export function handoffSwitches() {
  try {
    if (localStorage.getItem(PREVIEW_KEY) === 'on') return { meet: true, talk: true, seer: true };
  } catch (e) { /* storage blocked */ }
  return OFF;
}

export function anyHandoffOn(switches = handoffSwitches()) {
  return Boolean(switches.meet || switches.talk || switches.seer);
}
